import React from "react";
import { Image, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

import { styledWithTheme } from "../../../styles/theme";
import SimpleButton, {
  definedButtonTypes,
} from "../../atoms/Buttons/SimpleButton/SimpleButton";
import { LOGO } from "../../../images/imageSources";
import useMobileDetector from "../../../hooks/useMobileDetector";

const StyledButtonBar = styledWithTheme.div({
  "&&&": {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1em",
    marginTop: "0",
    flexWrap: "wrap",
    ".image": {
      marginTop: "auto",
      paddingBottom: "0.6em",
    },
    ".button": {
      alignSelf: "flex-end",
      marginLeft: "auto",
    },
  },
});

interface Props {
  mapView: boolean;
  toggleMapView: () => void;
  showMapButton: boolean;
}

const IFrameHeader: React.FC<Props> = ({
  showMapButton,
  toggleMapView,
  mapView,
}) => {
  const { t } = useTranslation();
  const isMobile = useMobileDetector(425);

  const icon = mapView ? "grid layout" : "map";
  let btnText = "EventMap";
  if (isMobile && mapView) {
    btnText = "GridList";
  } else if (isMobile) {
    btnText = "Map";
  } else if (mapView) {
    btnText = "EventGridList";
  }

  return (
    <StyledButtonBar>
      <Image
        src={LOGO}
        alt="logo"
        href="https://www.latviesi.com"
        target="_blank"
        width="120px"
      />
      {showMapButton && (
        <SimpleButton
          variant={definedButtonTypes.basic}
          onClick={toggleMapView}
          id={btnText}
        >
          <Icon name={icon} />
          {t(btnText)}
        </SimpleButton>
      )}
    </StyledButtonBar>
  );
};

export default IFrameHeader;
